var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$auth.check(['UFS', 'SUPER']))?_c('div',{staticClass:"animated fadeIn"},[_vm._v("\n  Dashboard do Inpar\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }